"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/recurring-transfer-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Frecurring-transfer-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurringTransferServiceClient = exports.EvaluateAllSchedulesResponseScheduleNextTransferPair = exports.EvaluateAllSchedulesResponse = exports.EvaluateAllSchedulesRequest = exports.EvaluateScheduleResponse = exports.EvaluateScheduleRequest = exports.UpdateDateResponse = exports.UpdateDateRequest = exports.GetAllResponse = exports.GetAllRequest = exports.UpdateResponse = exports.UpdateRequest = exports.CreateResponse = exports.CreateRequest = exports.SetResponse = exports.SetRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const date_1 = require("../common/date");
const recurring_transfer_1 = require("./recurring-transfer");
const recurring_transfer_date_1 = require("./recurring-transfer-date");
const transfer_instructions_1 = require("./transfer-instructions");
const protobufPackage = 'com.step.transfer.recurring.proto';
function createBaseSetRequest() {
    return {
        instructions: transfer_instructions_1.TransferInstructions.fromPartial({}),
        schedule: recurring_transfer_1.TransferSchedule.fromPartial({}),
        enabled: false,
        timeZone: '',
    };
}
exports.SetRequest = {
    fromJSON(object) {
        const message = {
            instructions: isSet(object.instructions)
                ? transfer_instructions_1.TransferInstructions.fromJSON(object.instructions)
                : transfer_instructions_1.TransferInstructions.fromPartial({}),
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.enabled)) {
            message.enabled = globalThis.Boolean(object.enabled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instructions !== undefined) {
            obj.instructions = transfer_instructions_1.TransferInstructions.toJSON(message.instructions);
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.enabled !== undefined && message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        return obj;
    },
    create(base) {
        return exports.SetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetRequest();
        message.instructions = (object.instructions !== undefined && object.instructions !== null)
            ? transfer_instructions_1.TransferInstructions.fromPartial(object.instructions)
            : transfer_instructions_1.TransferInstructions.fromPartial({});
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.enabled = object.enabled ?? false;
        message.timeZone = object.timeZone ?? '';
        return message;
    },
};
function createBaseSetResponse() {
    return { transfer: recurring_transfer_1.RecurringTransfer.fromPartial({}) };
}
exports.SetResponse = {
    fromJSON(object) {
        const message = {
            transfer: isSet(object.transfer)
                ? recurring_transfer_1.RecurringTransfer.fromJSON(object.transfer)
                : recurring_transfer_1.RecurringTransfer.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfer !== undefined) {
            obj.transfer = recurring_transfer_1.RecurringTransfer.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.SetResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetResponse();
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? recurring_transfer_1.RecurringTransfer.fromPartial(object.transfer)
            : recurring_transfer_1.RecurringTransfer.fromPartial({});
        return message;
    },
};
function createBaseCreateRequest() {
    return {
        instructions: transfer_instructions_1.TransferInstructions.fromPartial({}),
        schedule: recurring_transfer_1.TransferSchedule.fromPartial({}),
        timeZone: '',
        nonce: '',
    };
}
exports.CreateRequest = {
    fromJSON(object) {
        const message = {
            instructions: isSet(object.instructions)
                ? transfer_instructions_1.TransferInstructions.fromJSON(object.instructions)
                : transfer_instructions_1.TransferInstructions.fromPartial({}),
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
            nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instructions !== undefined) {
            obj.instructions = transfer_instructions_1.TransferInstructions.toJSON(message.instructions);
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        if (message.nonce !== '') {
            obj.nonce = message.nonce;
        }
        return obj;
    },
    create(base) {
        return exports.CreateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateRequest();
        message.instructions = (object.instructions !== undefined && object.instructions !== null)
            ? transfer_instructions_1.TransferInstructions.fromPartial(object.instructions)
            : transfer_instructions_1.TransferInstructions.fromPartial({});
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.timeZone = object.timeZone ?? '';
        message.nonce = object.nonce ?? '';
        return message;
    },
};
function createBaseCreateResponse() {
    return { transfer: recurring_transfer_1.RecurringTransfer.fromPartial({}) };
}
exports.CreateResponse = {
    fromJSON(object) {
        const message = {
            transfer: isSet(object.transfer)
                ? recurring_transfer_1.RecurringTransfer.fromJSON(object.transfer)
                : recurring_transfer_1.RecurringTransfer.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfer !== undefined) {
            obj.transfer = recurring_transfer_1.RecurringTransfer.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.CreateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateResponse();
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? recurring_transfer_1.RecurringTransfer.fromPartial(object.transfer)
            : recurring_transfer_1.RecurringTransfer.fromPartial({});
        return message;
    },
};
function createBaseUpdateRequest() {
    return { transferId: '', instructions: undefined, schedule: undefined, enabled: undefined };
}
exports.UpdateRequest = {
    fromJSON(object) {
        const message = {
            transferId: isSet(object.transferId) ? globalThis.String(object.transferId) : '',
        };
        if (isSet(object.instructions)) {
            message.instructions = transfer_instructions_1.TransferInstructions.fromJSON(object.instructions);
        }
        if (isSet(object.schedule)) {
            message.schedule = recurring_transfer_1.TransferSchedule.fromJSON(object.schedule);
        }
        if (isSet(object.enabled)) {
            message.enabled = globalThis.Boolean(object.enabled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferId !== '') {
            obj.transferId = message.transferId;
        }
        if (message.instructions !== undefined) {
            obj.instructions = transfer_instructions_1.TransferInstructions.toJSON(message.instructions);
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.enabled !== undefined) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateRequest();
        message.transferId = object.transferId ?? '';
        message.instructions = (object.instructions !== undefined && object.instructions !== null)
            ? transfer_instructions_1.TransferInstructions.fromPartial(object.instructions)
            : undefined;
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : undefined;
        message.enabled = object.enabled ?? undefined;
        return message;
    },
};
function createBaseUpdateResponse() {
    return { transfer: recurring_transfer_1.RecurringTransfer.fromPartial({}) };
}
exports.UpdateResponse = {
    fromJSON(object) {
        const message = {
            transfer: isSet(object.transfer)
                ? recurring_transfer_1.RecurringTransfer.fromJSON(object.transfer)
                : recurring_transfer_1.RecurringTransfer.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfer !== undefined) {
            obj.transfer = recurring_transfer_1.RecurringTransfer.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateResponse();
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? recurring_transfer_1.RecurringTransfer.fromPartial(object.transfer)
            : recurring_transfer_1.RecurringTransfer.fromPartial({});
        return message;
    },
};
function createBaseGetAllRequest() {
    return { statuses: [] };
}
exports.GetAllRequest = {
    fromJSON(object) {
        const message = {
            statuses: globalThis.Array.isArray(object?.statuses)
                ? object.statuses.map((e) => (0, recurring_transfer_1.recurringTransferStatusFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.statuses?.length) {
            obj.statuses = message.statuses.map((e) => (0, recurring_transfer_1.recurringTransferStatusToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAllRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAllRequest();
        message.statuses = object.statuses?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetAllResponse() {
    return { transfers: [] };
}
exports.GetAllResponse = {
    fromJSON(object) {
        const message = {
            transfers: globalThis.Array.isArray(object?.transfers)
                ? object.transfers.map((e) => recurring_transfer_1.RecurringTransfer.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfers?.length) {
            obj.transfers = message.transfers.map((e) => recurring_transfer_1.RecurringTransfer.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAllResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAllResponse();
        message.transfers = object.transfers?.map((e) => recurring_transfer_1.RecurringTransfer.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateDateRequest() {
    return { transferDateId: '', shouldSkip: false };
}
exports.UpdateDateRequest = {
    fromJSON(object) {
        const message = {
            transferDateId: isSet(object.transferDateId) ? globalThis.String(object.transferDateId) : '',
        };
        if (isSet(object.shouldSkip)) {
            message.shouldSkip = globalThis.Boolean(object.shouldSkip);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferDateId !== '') {
            obj.transferDateId = message.transferDateId;
        }
        if (message.shouldSkip !== undefined && message.shouldSkip !== false) {
            obj.shouldSkip = message.shouldSkip;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateDateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateDateRequest();
        message.transferDateId = object.transferDateId ?? '';
        message.shouldSkip = object.shouldSkip ?? false;
        return message;
    },
};
function createBaseUpdateDateResponse() {
    return { transferDate: recurring_transfer_date_1.RecurringTransferDate.fromPartial({}) };
}
exports.UpdateDateResponse = {
    fromJSON(object) {
        const message = {
            transferDate: isSet(object.transferDate)
                ? recurring_transfer_date_1.RecurringTransferDate.fromJSON(object.transferDate)
                : recurring_transfer_date_1.RecurringTransferDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferDate !== undefined) {
            obj.transferDate = recurring_transfer_date_1.RecurringTransferDate.toJSON(message.transferDate);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateDateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateDateResponse();
        message.transferDate = (object.transferDate !== undefined && object.transferDate !== null)
            ? recurring_transfer_date_1.RecurringTransferDate.fromPartial(object.transferDate)
            : recurring_transfer_date_1.RecurringTransferDate.fromPartial({});
        return message;
    },
};
function createBaseEvaluateScheduleRequest() {
    return {
        source: transfer_instructions_1.TransferSource.fromPartial({}),
        schedule: recurring_transfer_1.TransferSchedule.fromPartial({}),
        timeZone: '',
        lastTransferDate: undefined,
    };
}
exports.EvaluateScheduleRequest = {
    fromJSON(object) {
        const message = {
            source: isSet(object.source)
                ? transfer_instructions_1.TransferSource.fromJSON(object.source)
                : transfer_instructions_1.TransferSource.fromPartial({}),
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.lastTransferDate)) {
            message.lastTransferDate = date_1.DateMessage.fromJSON(object.lastTransferDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = transfer_instructions_1.TransferSource.toJSON(message.source);
        }
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        if (message.lastTransferDate !== undefined) {
            obj.lastTransferDate = date_1.DateMessage.toJSON(message.lastTransferDate);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateScheduleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateScheduleRequest();
        message.source = (object.source !== undefined && object.source !== null)
            ? transfer_instructions_1.TransferSource.fromPartial(object.source)
            : transfer_instructions_1.TransferSource.fromPartial({});
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.timeZone = object.timeZone ?? '';
        message.lastTransferDate =
            (object.lastTransferDate !== undefined && object.lastTransferDate !== null)
                ? date_1.DateMessage.fromPartial(object.lastTransferDate)
                : undefined;
        return message;
    },
};
function createBaseEvaluateScheduleResponse() {
    return { next: [] };
}
exports.EvaluateScheduleResponse = {
    fromJSON(object) {
        const message = {
            next: globalThis.Array.isArray(object?.next)
                ? object.next.map((e) => date_1.DateMessage.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.next?.length) {
            obj.next = message.next.map((e) => date_1.DateMessage.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateScheduleResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateScheduleResponse();
        message.next = object.next?.map((e) => date_1.DateMessage.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluateAllSchedulesRequest() {
    return { source: transfer_instructions_1.TransferSource.fromPartial({}), timeZone: '', lastTransferDate: undefined };
}
exports.EvaluateAllSchedulesRequest = {
    fromJSON(object) {
        const message = {
            source: isSet(object.source)
                ? transfer_instructions_1.TransferSource.fromJSON(object.source)
                : transfer_instructions_1.TransferSource.fromPartial({}),
            timeZone: isSet(object.timeZone) ? globalThis.String(object.timeZone) : '',
        };
        if (isSet(object.lastTransferDate)) {
            message.lastTransferDate = date_1.DateMessage.fromJSON(object.lastTransferDate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = transfer_instructions_1.TransferSource.toJSON(message.source);
        }
        if (message.timeZone !== '') {
            obj.timeZone = message.timeZone;
        }
        if (message.lastTransferDate !== undefined) {
            obj.lastTransferDate = date_1.DateMessage.toJSON(message.lastTransferDate);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesRequest();
        message.source = (object.source !== undefined && object.source !== null)
            ? transfer_instructions_1.TransferSource.fromPartial(object.source)
            : transfer_instructions_1.TransferSource.fromPartial({});
        message.timeZone = object.timeZone ?? '';
        message.lastTransferDate =
            (object.lastTransferDate !== undefined && object.lastTransferDate !== null)
                ? date_1.DateMessage.fromPartial(object.lastTransferDate)
                : undefined;
        return message;
    },
};
function createBaseEvaluateAllSchedulesResponse() {
    return { nextTransfers: [] };
}
exports.EvaluateAllSchedulesResponse = {
    fromJSON(object) {
        const message = {
            nextTransfers: globalThis.Array.isArray(object?.nextTransfers)
                ? object.nextTransfers.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nextTransfers?.length) {
            obj.nextTransfers = message.nextTransfers.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesResponse();
        message.nextTransfers =
            object.nextTransfers?.map((e) => exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluateAllSchedulesResponseScheduleNextTransferPair() {
    return { schedule: recurring_transfer_1.TransferSchedule.fromPartial({}), nextTransfer: undefined };
}
exports.EvaluateAllSchedulesResponseScheduleNextTransferPair = {
    fromJSON(object) {
        const message = {
            schedule: isSet(object.schedule)
                ? recurring_transfer_1.TransferSchedule.fromJSON(object.schedule)
                : recurring_transfer_1.TransferSchedule.fromPartial({}),
        };
        if (isSet(object.nextTransfer)) {
            message.nextTransfer = date_1.DateMessage.fromJSON(object.nextTransfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.schedule !== undefined) {
            obj.schedule = recurring_transfer_1.TransferSchedule.toJSON(message.schedule);
        }
        if (message.nextTransfer !== undefined) {
            obj.nextTransfer = date_1.DateMessage.toJSON(message.nextTransfer);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluateAllSchedulesResponseScheduleNextTransferPair.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluateAllSchedulesResponseScheduleNextTransferPair();
        message.schedule = (object.schedule !== undefined && object.schedule !== null)
            ? recurring_transfer_1.TransferSchedule.fromPartial(object.schedule)
            : recurring_transfer_1.TransferSchedule.fromPartial({});
        message.nextTransfer = (object.nextTransfer !== undefined && object.nextTransfer !== null)
            ? date_1.DateMessage.fromPartial(object.nextTransfer)
            : undefined;
        return message;
    },
};
/**
 * Recurring transfer service.
 */
class RecurringTransferServiceClient {
    rpc;
    name = 'com.step.transfer.recurring.proto.RecurringTransferService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/transfer';
    methods = [{
            name: 'Set',
            requestType: exports.SetRequest,
            responseType: exports.SetResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Create',
            requestType: exports.CreateRequest,
            responseType: exports.CreateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetAll',
            requestType: exports.GetAllRequest,
            responseType: exports.GetAllResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Update',
            requestType: exports.UpdateRequest,
            responseType: exports.UpdateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdateDate',
            requestType: exports.UpdateDateRequest,
            responseType: exports.UpdateDateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EvaluateSchedule',
            requestType: exports.EvaluateScheduleRequest,
            responseType: exports.EvaluateScheduleResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EvaluateAllSchedules',
            requestType: exports.EvaluateAllSchedulesRequest,
            responseType: exports.EvaluateAllSchedulesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    set(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    create(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getAll(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    update(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    updateDate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    evaluateSchedule(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    evaluateAllSchedules(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.RecurringTransferServiceClient = RecurringTransferServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=recurring-transfer-service.js.map